import { render, staticRenderFns } from "./nitofications.vue?vue&type=template&id=5b517b12&"
import script from "./nitofications.vue?vue&type=script&lang=js&"
export * from "./nitofications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports